<template>
	<am-button
		class="am-submit"
		:class="{
			'is-idle': state == 'idle',
			'is-loading': state == 'loading',
			'is-done': state == 'done'
		}"
		:filled="true"
		@click="$emit('click', state)"
	>
		<div class="am-submit__send">
			<am-icon name="send" :dark="true" size="sm" />
			Enviar
		</div>

		<div class="am-submit__sent">
			<am-icon name="check" :dark="true" size="sm" />
			Enviado
		</div>

		<img class="am-submit__loading" src="/images/loading.svg">
	</am-button>
</template>

<script>
import AMButton from '@/components/molecules/AMButton'
import AMIcon from '@/components/atoms/AMIcon'

export default {
	components: {
		'am-icon': AMIcon,
		'am-button': AMButton
	},

	props: {
		state: {
			type: String,
			default: 'idle'
		}
	}
}
</script>

<style lang="scss">
.am-submit{
	width: 120px;
	padding: 0;
	position: relative;
	transition: .3s $easeInOutQuad;
	overflow: hidden;
	&__send,
	&__sent{
		position: absolute;
		top: 50%;
		left: 50%;
		display: flex;
		align-items: center;
		transition: .4s $easeInOutQuad;
		.am-icon{
			margin-right: 8px;
		}
	}
	&__send{
		transform: translate(-50%, -50%);
	}
	&__sent{
		transform: translate(-50%, 40px);
	}
	&__loading{
		position: absolute;
		top: 8px;
		right: 8px;
		animation-name: loading;
		animation-iteration-count: infinite;
		animation-duration: .6s;
		animation-timing-function: linear;
		transition: .4s $easeInOutQuad;
		opacity: 0;
	}

	&.is-idle{
	}

	&.is-loading{
		width: 44px;
		background: #B4B3B4 !important;
		border-color: #B4B3B4 !important;
		.am-submit{
			&__send{
				transform: translate(100%, -50%);
			}
			&__loading{
				opacity: 1;
			}
		}
	}

	&.is-done{
		background: #80b764 !important;
		border-color: #80b764 !important;
		.am-submit{
			&__send{
				transform: translate(-50%, -40px);
				transition: none;
			}
			&__sent{
				transform: translate(-50%, -50%);
			}
		}
	}
}

@keyframes loading {
	0% {
		transform: rotate(0deg);
	}
	100% {
		transform: rotate(360deg);
	}
}
</style>
